import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-elk",
  "use": "icon-elk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-elk\"><defs><style type=\"text/css\"></style></defs><path d=\"M533.333333 725.333333c-113.066667 0-206.933333-93.866667-206.933333-206.933333V512c0-110.933333 89.6-198.4 198.4-198.4h251.733333c46.933333 0 68.266667-55.466667 36.266667-87.466667-72.533333-74.666667-172.8-117.333333-283.733333-115.2-204.8 2.133333-386.133333 177.066667-396.8 381.866667-10.666667 230.4 172.8 422.4 401.066666 422.4 102.4 0 196.266667-38.4 266.666667-100.266667 36.266667-32 14.933333-91.733333-34.133333-91.733333L533.333333 725.333333z\" fill=\"#00C1DE\" p-id=\"1404\" /><path d=\"M827.733333 616.533333H533.333333c-55.466667 0-102.4-44.8-102.4-102.4V512c0-55.466667 44.8-102.4 102.4-102.4h294.4c55.466667 0 102.4 44.8 102.4 102.4v2.133333c-2.133333 55.466667-46.933333 102.4-102.4 102.4z\" fill=\"#00C1DE\" p-id=\"1405\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/elk.svg
// module id = ttoD
// module chunks = 307